import { date } from 'quasar'

// "async" is optional;
// more info on params: https://quasar.dev/quasar-cli/boot-files

const dateFormat = (_date) => {
  const format = date.formatDate(_date, 'DD-MM-YYYY')
  return format
}


export default ({ Vue }) => {
  Vue.filter('dateFormat', dateFormat)
}
